import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  return (
    <div className="product-detail main">
      <div className="product-detail__container">
        <div className="product-detail__breadcrumbs">
          <Link to="/shop" onClick={toTop}>
            Shop
          </Link>
          <span> / </span>
          <span>{product.name}</span>
        </div>

        <div className="product-detail__content">
          <div className="product-detail__images">
            <div className="product-detail__thumbnails">
              {product.images &&
                product.images.map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setImage(idx)}
                    className={`product-detail__thumbnail ${
                      selectedImage === idx ? "active" : ""
                    }`}
                  >
                    <img src={img} alt={`${product.name} ${idx + 1}`} />
                  </button>
                ))}
            </div>
            <div className="product-detail__main-image">
              <img src={product.images[selectedImage]} alt={product.name} />
            </div>
          </div>

          <div className="product-detail__info">
            <div className="product-detail__vendor">{product.category}</div>
            <h1 className="product-detail__title">{product.name}</h1>
            <div className="product-detail__rating">
              <div className="product-detail__stars">
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star"></i>
                <i className="fas fa-star-half-alt"></i>
              </div>
              <span>({product.reviews})</span>
            </div>
            <div className="product-detail__price">${product.price}</div>

            {product.size && product.size.length > 0 && (
              <div className="product-detail__options">
                <div className="product-detail__option-label">Amount</div>
                <div className="product-detail__sizes">
                  {product.size.map((size, idx) => (
                    <button
                      key={idx}
                      onClick={() => setSelectedSize(size)}
                      className={`product-detail__size-btn ${
                        selectedSize === size ? "active" : ""
                      }`}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {product.colors && product.colors.length > 0 && (
              <div className="product-detail__options">
                <div className="product-detail__option-label">
                  Purchase options
                </div>
                <div className="product-detail__colors">
                  {product.colors.map((color, idx) => (
                    <label
                      key={idx}
                      className={`product-detail__color-btn ${
                        selectedColor === color ? "active" : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name="color"
                        value={color}
                        checked={selectedColor === color}
                        onChange={(e) => setSelectedColor(e.target.value)}
                      />
                      <span>{color}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}

            <div className="product-detail__actions">
              <button
                className="product-detail__add-to-cart"
                onClick={handleAddToCart}
              >
                ADD TO CART
              </button>
            </div>

            <div className="product-detail__description">
              <p>{product.description[0]}</p>
              {product.description.slice(1).map((desc, idx) => (
                <p key={idx}>{desc}</p>
              ))}
              {product.Features &&
                product.Features.map((feature, idx) => (
                  <p key={idx}>
                    <strong>{feature.split(":")[0]}:</strong>{" "}
                    {feature.split(":").slice(1).join(":")}
                  </p>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
